<template>
    <div class="c_create_official">
        <div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
        <!-- <a-row :gutter="24" type="flex" style="margin-top: -100px;"> -->
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-20">
                <!-- <a-card :bordered="false" class="card-profile-head " :bodyStyle="{padding: 0}"> -->
                <height-watcher>
                    <div
                        class="budgets-page-body"
                        slot-scope="{ height, offset }"
                        :offset="offset"
                        :style="{
                            'max-height': height - (234) + 'px',
                            height: height - (234) + 'px',
                        }"
                    >
                        <a-card :bordered="false" 
                            class=" header-solid h-full widget-1" 
                            :bodyStyle="{paddingTop: 0}"
                            style="min-height: 670px;
                                max-height: 670px;
                                overflow-y: scroll;
                                margin-bottom: 0px;
                                margin-top:-170px;
                                margin-left: 5%;
                                margin-right: 5%"
                        >
                            <template #title>
                                <a-row type="flex" align="middle">
                                    <a-col :span="24" :md="12" style="margin-bottom:30px">
                                        <h5 class="font-semibold m-0">{{$t('official-create-page.sub-title')}}</h5>
                                    </a-col>
                                </a-row>
                            </template>

                            <template >
                                <a-spin :spinning="isLoading" size="large" >
                                    <a-form
                                        id="components-form-demo-normal-login"
                                        class="login-form"
                                        style="min-height: 540px !important;"
                                        @submit="handleSubmit"
                                        :hideRequiredMark="true">
                                        
                                        <a-form-item class="mb-5">	
                                                <!-- :label= "$t('form-label.name-en')" -->
                                            <a-form-item
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }" 
                                                :validate-status="validations.statusNameEn"
                                                :help="validations.helpNameEn">

                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.name-en')}} <b style="color:red">(*)</b>
                                                </label>

                                                <a-input
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.name-en')"
                                                    v-model="name"
                                                />
                                            </a-form-item>

                                                <!-- :label= "$t('form-label.name-bn')"  -->
                                            <a-form-item
                                                class="ml-10" 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }" 
                                                :validate-status="validations.statusNameBn"
                                                :help="validations.helpNameBn">
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.name-bn')}} <b style="color:red">(*)</b>
                                                </label>
                                                <a-input
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.name-bn')"
                                                    v-model="nameBn"
                                                />
                                            </a-form-item>
                                            
                                            <!-- <a-form-item
                                                label="Email (*)" 
                                                class="ml-10" 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }" 
                                                :validate-status="validations.statusEmail"
                                                :help="validations.helpEmail">
                                                <a-input
                                                    class="form-input"
                                                    placeholder="Email"
                                                    v-model="email"
                                                />
                                            </a-form-item> -->
                                        </a-form-item>

                                        

                                        <a-form-item >
                                                <!-- :label= "$t('form-label.mobile')" -->
                                            <a-form-item
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }" 
                                                :validate-status="validations.statusMobile"
                                                :help="validations.helpMobile">
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.mobile')}} <b style="color:red">(*)</b>
                                                </label>
                                                <a-input
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.mobile')"
                                                    v-model="mobile"
                                                >
                                                </a-input>
                                            </a-form-item>

                                                <!-- :label= "$t('form-label.email')" -->
                                            <a-form-item
                                                class="ml-10" 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }" 
                                                :validate-status="validations.statusEmail"
                                                :help="validations.helpEmail">
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.email')}} <b style="color:red">(*)</b>
                                                </label>
                                                <a-input
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.email')"
                                                    v-model="email"
                                                />
                                            </a-form-item>

                                            

                                        </a-form-item>

                                        <a-form-item >
                                                <!-- :label= "$t('form-label.department')" -->
                                            <a-form-item
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                                                :validate-status="validations.statusSelectedDepartment"
                                                :help="validations.helpSelectedDepartment"
                                            >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.department')}} <b style="color:red">(*)</b>
                                                </label>
                                                <a-select
                                                    :disabled="isLoading"
                                                    :loading="isLoading"
                                                    :not-found-content="isLoading ? undefined : null"
                                                    :value="selectedDepartment"
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.department')"
                                                    :filter-option="false"
                                                    @search="filterDepartment"
                                                    @change="onChangeDepartmentSelection"
                                                >
                                                    <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                                                    <a-select-option v-for="item in departments" :key="item.id" :value="item.id">
                                                        <span role="img" style="margin-right: 20px;">
                                                            <a-avatar shape="square" :src="item.imageUrl" />
                                                        </span>
                                                        {{ item.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>


                                                <!-- :label= "$t('form-label.designation')" -->
                                            <a-form-item
                                                class="ml-10" 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                                                :validate-status="validations.statusSelectedDesignation"
                                                :help="validations.helpSelectedDesignation"
                                            >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.designation')}} <b style="color:red">(*)</b>
                                                </label>
                                                <a-select
                                                    :disabled="isLoading"
                                                    :loading="isLoading"
                                                    :not-found-content="isLoading ? undefined : null"
                                                    :value="selectedDesignation"
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.designation')"
                                                    :filter-option="false"
                                                    @search="filterDesignation"
                                                    @change="onChangeDesignationSelection"
                                                >
                                                    <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                                                    <a-select-option v-for="item in designations" :key="item.id" :value="item.id">
                                                        <span role="img" style="margin-right: 20px;">
                                                            <a-avatar shape="square" :src="item.imageUrl" />
                                                        </span>
                                                        {{ item.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-form-item>

                                        <a-form-item >
                                                <!-- :label= "$t('form-label.gender')" -->
                                            <a-form-item
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                                            >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.gender')}}
                                                </label>

                                                <a-select
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.gender')"
                                                    @change="onChangeGenderSelection"
                                                >
                                                    <a-select-option v-for="item in $t('dropdown-items.genders')" :key="item" :value="item">
                                                        {{ item }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>

                                                <!-- :label= "$t('form-label.password')"  -->
                                            <a-form-item
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                                                class="ml-10" 
                                            >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.password')}}
                                                </label>
                                                <a-input
                                                    type= "password"
                                                    class="form-input"
                                                    :placeholder= "$t('form-placeholder.password')"
                                                    v-model="password"
                                                />
                                            </a-form-item>
                                        </a-form-item>

                                        <a-form-item >

                                                <!-- :label= "$t('form-label.status')" -->
                                            <a-form-item 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)', top: '10px' }"
                                                
                                                >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.status')}}
                                                </label>
                                                    <!-- placeholder="Select a option and change input text above" -->
                                                <a-select
                                                    :placeholder= "$t('form-placeholder.status')"
                                                    @change="onChangeStatusSelection"
                                                    :default-value="$t('dropdown-items.default-selected-status')"
                                                >
                                                    <!-- default-value="ACTIVE" -->
                                                    <a-select-option v-for="item in $t('dropdown-items.all-status')" :key="item" :value="item">
                                                        {{ item }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                            <!-- <a-form-item
                                                class="ml-10" 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                                            >
                                                <img 
                                                    id="official-image" 
                                                    class="ml-10 mt-5" 
                                                    height="150" width="150" 
                                                    :src="image.src" 
                                                    style="object-fit: contain" 
                                                />
                                            </a-form-item> -->

                                            <a-form-item class="c_image_upload_form_item" :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
                                                <img 
                                                    id="official-image" 
                                                    class="ml-20 " 
                                                    height="100" width="100" 
                                                    :src="image.src" 
                                                    style="object-fit: contain" 
                                                />
                                                <a-form-item
                                                    class="ml-30" :style="{ display: 'inline-block', width: 'calc(60% - 12px)'}" 
                                                >
                                                    <div 
                                                        style="position:relative;
                                                            display: flex; 
                                                            height: 200px; 
                                                            flex-direction: column;  
                                                            justify-content: center;
                                                            bottom:1.5rem;
                                                            "
                                                    >
                                                        <a-button block type="success"  @click="pickImage">
                                                            <a-icon type="upload" :style="{ 'font-weight': 800 }" />  
                                                            <span>{{$t('form-label.img-select-btn-caption')}}</span>
                                                        </a-button>

                                                        <input
                                                            type="file"
                                                            ref="imageInput"
                                                            @change="uploadImage($event)"
                                                            accept="image/*"
                                                            v-show="false"
                                                        />
                                                    </div>
                                                </a-form-item>
                                            </a-form-item>

                                        </a-form-item>

                                        <a-form-item>
                                                <!-- :label= "$t('form-label.note')" -->
                                            <a-form-item 
                                                :style="{ display: 'inline-block', width: 'calc(50% - 12px)',bottom: '70px' }" 
                                            >
                                                <label 
                                                    class="ml-10" 
                                                    style="color: #000; font-weight:600"
                                                >{{$t('form-label.note')}}
                                                </label>
                                                <a-textarea 
                                                    :placeholder= "$t('form-placeholder.note')" 
                                                    :rows="4" v-model="note"
                                                />
                                            </a-form-item>

                                            
                                        </a-form-item>

                                        <a-row type="flex" align="middle" style="position:relative; top: 50px">
                                            <a-form-item 
                                                :style="{ display: 'inline-block', bottom:'80px'}"
                                                :wrapper-col="{ span: 24, offset: 0 }">
                                                <a-button type="primary" class="mr-10 mt-40" html-type="submit">
                                                    {{$t('official-create-page.submit-btn-caption')}}
                                                </a-button>
                                                <a-button type="danger"  @click="navigateTo('Officials')">
                                                    {{$t('department-update-page.cancel-btn-caption')}}
                                                </a-button>
                                            </a-form-item>
                                        </a-row>

                                    </a-form>
                                </a-spin>
                            </template>
                        </a-card>
                    </div>
                </height-watcher>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { toastMixin } from "../../mixins/ToastMixin.js";
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import { host, departmentsClient, designationsClient, uploadClient, officialsClient } from "../../api/config.js";
import { BanglaUtils } from "../../helpers/bangla-utils.js";
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue"
export default {
    name: "CreateOfficial",
    components: {
        HeightWatcher
    },
    mixins: [ toastMixin, navigationMixin ],
    data() {
        return {
            // allStatus: ["ACTIVE","INACTIVE"],
            selectedDepartment: "",
            selectedDepartmentId: "",
            selectedDesignation: "",
            selectedDesignationId: "",
            name: "",
            status: "ACTIVE",
            nameBn: "",
            email: "",
            mobile: "",
            password: "",
            designationId: "",
            departmentId: "",
            gender: "",
            note: "",
            code: "",
            imageUrl: "",
            extras: {},
            userNameField: "",
            image: {
                src: '/images/default-avatar.jpg',
                type: '',
                file: null,
            },
            // genders:["Male","Female"],
            validations: {
                statusNameEn: '',
                helpNameEn: '',
                statusNameBn: '',
                helpNameBn: '',
                statusEmail: '',
                helpEmail: '',
                statusMobile: '',
                helpMobile: '',
                statusNote: '',
                helpNote: '',
                statusSelectedDepartment: "",
                helpSelectedDepartment: "",
                statusSelectedDesignation: "",
                helpSelectedDesignation: "",

            },
            value: {},
            departments: [],
            allDepartments: [],
            designations: [],
            allDesignations: [],
            isLoading: false,
        }
    },
    methods:{
        onChangeStatusSelection(e){
            this.status = e;
        },
        pickImage() {
            this.$refs.imageInput.click()
        },
        uploadImage(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();

                this.image.type =  event.target.files[0].type;
                this.image.file = file;
                console.log(file);
                
                
                reader.onload = event => {
                    this.image.src = (reader.result);
                    this.$emit('change', this.image);
                    console.log(reader.result);
                    
                };
                reader.readAsDataURL(file);

                this.officialImageUrl(file);

            }
        },

        officialImageUrl(file) {
            return new Promise((resolve, reject) => {
                if (file) {
                    uploadClient.upload(file, 'official-image').then(res => {
                        if (!res.networkError) {
                            if (res.status == 201 && res.body) {
                                this.imageUrl = res.body.url;
                                console.log("image url is ");
                                console.log(this.imageUrl);
                            } else {
                                this.errorToast(this.$t('toast-error-messages.upload-official-image') + res.status);
                                reject();
                            }
                        } else {
                            this.errorToast(this.$t('toast-error-messages.network-error'));
                            reject();
                        }
                    });
                } else {
                    resolve();
                }
            });
        },
        onChangeGenderSelection(e){
            this.gender = e;
            console.log("gender is ==>> " + this.gender);
        },
        onChangeDepartmentSelection(e) {
            this.departmentId = e;
            this.selectedDepartment = e;
            this.selectedDepartmentId = e;
            console.log("department id is ====>>>>>" + this.departmentId);
        },
        filterDepartment(input) {
            this.departments = this.allDepartments.filter(o => o.name.toLowerCase().includes(input.toLowerCase()));
        },
        onChangeDesignationSelection(e) {
            this.designationId = e;
            this.selectedDesignation = e;
            this.selectedDesignationId = e;
            console.log("designation id is ===>>>>"+this.designationId);
        },
        filterDesignation(input) {
            this.designations = this.allDesignations.filter(o => o.name.toLowerCase().includes(input.toLowerCase()));
        },

        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },

        validate() {
        
            this.clearValidations();
            
            if (this.name.trim().length == 0) {
                this.validations.statusNameEn = 'error';
                this.validations.helpNameEn = this.$t('error-message.name');
                return false;
            }
            if (this.nameBn.trim().length == 0) {
                this.validations.statusNameBn = 'error';
                this.validations.helpNameBn = this.$t('error-message.name');
                return false;
            }
            if (this.mobile.trim().length == 0) {
                this.validations.statusMobile = 'error';
                this.validations.helpMobile = this.$t('error-message.mobile');
                return false;
            }
            if (this.email.trim().length == 0) {
                this.validations.statusEmail = 'error';
                this.validations.helpEmail = this.$t('error-message.email');
                return false;
            }

            if (!this.email.match(/\S+@\S+\.\S+/)) {
                this.validations.statusEmail = 'error';
                this.validations.helpEmail = this.$t('error-message.email');
                return false;
            }

            
            if (this.selectedDepartment.trim().length == 0) {
                this.validations.statusSelectedDepartment = 'error';
                this.validations.helpSelectedDepartment = this.$t('error-message.department');
                return false;
            }
            if (this.selectedDesignation.trim().length == 0) {
                this.validations.statusSelectedDesignation = 'error';
                this.validations.helpSelectedDesignation = this.$t('error-message.designation');
                return false;
            }

            let mobileEn = BanglaUtils.banglaToEnglishNumber(this.mobile);
            if (!mobileEn.match(/(^(\+8801|8801|01|008801))[1|3-9]{1}(\d){8}$/)) {
                this.validations.statusMobile = 'error';
                this.validations.helpMobile = this.$t('error-message.mobile');
                return false;
            }

            // if (!this.mobile.match(/(^(\+8801|8801|01|008801))[1|3-9]{1}(\d){8}$/)) {
            //     this.validations.statusMobile = 'error';
            //     this.validations.helpMobile = this.$t('error-message.mobile');
            //     return false;
            // }

            return true;

        },

        handleSubmit(e){
            console.log(e);
            e.preventDefault();

            if (this.validate()) {
                this.isLoading = true;
                let mobileEn = BanglaUtils.banglaToEnglishNumber(this.mobile);
                if (this.status == "সক্রিয়" || this.status == "ACTIVE"){
                    this.status = "ACTIVE";
                }
                if (this.status == "নিষ্ক্রিয়" || this.status == "INACTIVE"){
                    this.status = "INACTIVE";
                }
                if (this.gender == "পুরুষ" || this.gender == "Male"){
                    this.gender = "Male";
                }
                if (this.gender == "মহিলা" || this.gender == "Female"){
                    this.gender = "Female";
                }
                let submitData = {
                    name: this.name,
                    nameBn: this.nameBn,
                    status: this.status,
                    email: this.email,
                    mobile: (mobileEn.replace(/^((\s|\-)|(\+88|\88){1})/g, '')),
                    gender: this.gender,
                    departmentId: this.departmentId,
                    designationId: this.designationId,
                    note: this.note,
                    imageUrl: this.imageUrl,
                    password: this.password,
                    code: "",
                    extras: {},
                    userNameField: "email",
                }
                // console.log(submitData);
                this.uploadDataOnServer(submitData);
            }
        },
        uploadDataOnServer(data){
            officialsClient.create(data).then((res) => {
                if (!res.networkError) {
                    if (res.status == 201){
                        this.isLoading = false;
                        this.successToast(this.$t('toast-success-messages.create-official'));
                        this.navigateTo("Officials");
                    }else {
                        this.isLoading = false;
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);
                    }
                }else {
                    this.isLoading = false;
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                }
            })

        }
    },

    mounted(){
        this.isLoading = true;
        departmentsClient.fetchAllOfPage({ page: 1, size: 20 }).then(res => {
            if (!res.networkError && res.body && res.body.list) {
                res.body.list.forEach(o => {
                    if (!o.imageUrl || o.imageUrl.trim().length == 0)
                        o.imageUrl = '/images/default-avatar.jpg';
                    else
                        o.imageUrl = host + o.imageUrl;
                });
                this.allDepartments = res.body.list;
                this.departments = res.body.list;
            } else {
                /* TODO: show error */
            }
            this.isLoading = false;
        });


        designationsClient.fetchAllOfPage({ page: 1, size: 20 }).then(res => {
            if (!res.networkError && res.body && res.body.list) {
                res.body.list.forEach(o => {
                    if (!o.imageUrl || o.imageUrl.trim().length == 0)
                        o.imageUrl = '/images/default-avatar.jpg';
                    else
                        o.imageUrl = host + o.imageUrl;
                });
                this.allDesignations = res.body.list;
                this.designations = res.body.list;
            } else {
                /* TODO: show error */
            }
            this.isLoading = false;
        });
    }
}
</script>

<style>

</style>